import { message } from 'antd';
import * as ACTIONS from 'app/actions/OnSiteEvaluationsActions';

const initialState = {
    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },
    OnSiteEvaluationsFilters: {
        code: [],
        folio: [],
        name: [],
        trainings: [],
    },
    OnSiteEvaluationsCalFilters: {
        folio: [],
        idPresentialEvaluation: [],
        testFolio: [],
        employee: [],
        pernocta: [],
        name: [],
        description: []
    },
    OnSiteEvaluationsCal: [],
    TotalCalRows: 0,
    Filters: {},
    OnSiteEvaluations: [],
    AsignedUsers: [],
    TotalRows: 0,
    isLoading: false,
    error: '',
    isExportingF: false,
}

export default function OnSiteEvaluationReducer(state = initialState, action) {


    switch (action.type) {
        case ACTIONS.EVALUATIONS_EXPORTING_BEGIN:
            return {
                ...state,
                isExportingF: true
            }
        case ACTIONS.EVALUATIONS_EXPORTING_FINISH:
            let isExportingF = false;
            return {
                ...state,
                isExportingF
            }
        case ACTIONS.EVALUATIONS_CAL_BEGIN:
            return {
                ...state,
                isLoading: true,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_CAL_SUCCESS:
            let OnSiteEvaluationsCal = action.payload.Data;
            let TotalCalRows = action.payload.TotalRows;
            return {
                ...state,
                TotalCalRows,
                OnSiteEvaluationsCal,
                isLoading: false,
            }
        case ACTIONS.CLEAR_EVALUATIONS_CAL:
            return {
                ...state,
                OnSiteEvaluationsCal: [],
                TotalCalRows: 0,
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_CAL_FAILURE:
            return {
                ...state,
                isLoading: false,
                isExportingF: false
            }
        //End list Evaluations Cal
        case ACTIONS.EVALUATIONS_CAL_FILTERS_BEGIN:
            return {
                ...state,
                isLoading: true,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_CAL_FILTERS_SUCCESS:
         
            let OnSiteEvaluationsCalFilters = action.payload.result;
      
            return {
                ...state,
                OnSiteEvaluationsCalFilters,
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.CLEAR_EVALUATIONS_CAL_FILTERS:
            return {
                ...state,
                OnSiteEvaluationsCalFilters: {},
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_CAL_FILTERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                isExportingF: false
            }
        //End Califications
        case ACTIONS.EVALUATIONS_FILTERS_BEGIN:
            return {
                ...state,
                isLoading: true,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_FILTERS_SUCCESS:
            let OnSiteEvaluationsFilters = action.payload.data;

            return {
                ...state,
                OnSiteEvaluationsFilters,
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.CLEAR_EVALUATIONS_FILTERS:
            return {
                ...state,
                OnSiteEvaluationsFilters: {},
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_FILTERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_BEGIN:
            return {
                ...state,
                isLoading: true,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_SUCCESS:
            let OnSiteEvaluations = action.payload.Data;
            let TotalRows = action.payload.TotalRows;
            return {
                ...state,
                // OnSiteEvaluationsFilters,
                TotalRows,
                OnSiteEvaluations,
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.CLEAR_EVALUATIONS:
            return {
                ...state,
                OnSiteEvaluationsFilters: {},
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.EVALUATIONS_FAILURE:
            return {
                ...state,
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.USERS_EVALUATIONS_BEGIN:
            return {
                ...state,
                isLoading: true,
                isExportingF: false
            }
        case ACTIONS.USERS_EVALUATIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isExportingF: false
            }
        case ACTIONS.USERS_EVALUATIONS_FAILURE:
            return {
                ...state,
                AsignedUsers: [],
                isLoading: false,
                isExportingF: false
            }

        default:
            return { ...state, isExportingF: false };
    }

};

export const getOnSiteEvaluationsFilters = state => {
    return state.OnSiteEvaluationsFilters
}
export const getIsLoadingOnSiteEvaluationsilters = state => {
    return state.isLoading;
};

export const getOnSiteEvaluations = state => {
    return state.OnSiteEvaluations;
}

export const getOnSiteEvaluationsCalFilters = state => {
    return state.OnSiteEvaluationsCalFilters
}

export const getOnSiteEvaluationsCal = state => {
    return state.OnSiteEvaluationsCal;
}